import { clickTravelThreshold as defaultClickTravelThreshold } from "../config";
import { hotspotLocationEditorId } from "./constants";
export function getElementSize(el) {
  const rect = el.getBoundingClientRect();
  return [rect.right - rect.left, rect.bottom - rect.top];
}

export function getRelativeCoords(e, el) {
  const rect = el.getBoundingClientRect();
  return [e.clientX - rect.left, e.clientY - rect.top];
}

export function dragClickListener(
  e,
  {
    onDrag,
    onClick,
    onDragRelease,
    clickTravelThreshold = defaultClickTravelThreshold,
    onPointerDown,
  }
) {
  // Handle  only left-click e
  if (e.button !== 0) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  if (typeof onPointerDown === "function") {
    onPointerDown(e);
  }
  // remember and enclose the initial parameters
  const startX = e.clientX;
  const startY = e.clientY;
  let cumulativePointerTravelDistance = 0;
  let isClick = true;
  const pointerMoveListener = (e) => {
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    cumulativePointerTravelDistance += dx ** 2 + dy ** 2;
    // is it still a click?
    if (cumulativePointerTravelDistance > clickTravelThreshold ** 2) {
      isClick = false;
    }
    if (isClick) {
      return;
    }
    // it's a drag, process it
    onDrag(e, { dx, dy });
  };

  const pointerUpListener = (e) => {
    if (isClick && typeof onClick === "function") {
      onClick(e);
    } else if (typeof onDragRelease === "function") {
      onDragRelease();
    }
    document.removeEventListener("pointermove", pointerMoveListener);
    document.removeEventListener("pointerup", pointerUpListener);
  };

  document.addEventListener("pointermove", pointerMoveListener);
  document.addEventListener("pointerup", pointerUpListener);
}

export function getDesiredImageWidth(naturalAspect = 1) {
  const locationEditor = document.getElementById(hotspotLocationEditorId);
  const devicePixelRatio = window?.devicePixelRatio || 1;
  const availableHeight = locationEditor.clientWidth;
  const availableWidth = locationEditor.clientHeight;
  const heightLimitedWidth = availableHeight / naturalAspect;
  const width = Math.min(heightLimitedWidth, availableWidth);
  const requestedWidth = Math.ceil((width * devicePixelRatio) / 100) * 100;
  return requestedWidth;
}

export function clearCanvasByContext(ctx) {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}
